import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "kl-installation-user-list",
  templateUrl: "./installation-user-list.component.html",
  styleUrls: ["./installation-user-list.component.scss"],
})
export class InstallationUserListComponent implements OnInit {
  @Input() mode: string;
  @Input() tabId: string;
  @Input() modalId: string;
  filterSelectItems = [
    {
      name: "full_name",
      description: "fullname",
    },
    {
      name: "username",
      description: "username",
    },
  ];

  constructor() {}

  ngOnInit() {}
}
